import createSvgIcon from '@ixigo/icons/utils/createSvgIcon';
import { Fragment } from 'react';

export const AnimatedPulseCircle = createSvgIcon(
	<Fragment>
		<circle cx="12" cy="12" r="3" fill="currentColor" />
		<circle cx="12" cy="12" r="3" fill="currentColor">
			<animate
				attributeName="r"
				from="3"
				to="10"
				dur="2s"
				begin="0s"
				repeatCount="indefinite"
			/>
			<animate
				attributeName="opacity"
				from="1"
				to="0"
				dur="2s"
				begin="0s"
				repeatCount="indefinite"
			/>
		</circle>

		<circle cx="12" cy="12" r="3" fill="currentColor">
			<animate
				attributeName="r"
				from="3"
				to="10"
				dur="2s"
				begin="0.5s"
				repeatCount="indefinite"
			/>
			<animate
				attributeName="opacity"
				from="1"
				to="0"
				dur="2s"
				begin="0.5s"
				repeatCount="indefinite"
			/>
		</circle>

		<circle cx="12" cy="12" r="3" fill="currentColor">
			<animate
				attributeName="r"
				from="3"
				to="10"
				dur="2s"
				begin="1s"
				repeatCount="indefinite"
			/>
			<animate
				attributeName="opacity"
				from="1"
				to="0"
				dur="2s"
				begin="1s"
				repeatCount="indefinite"
			/>
		</circle>
	</Fragment>,
	'AnimatedPulseCircle',
);
